var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.26989 13.8182L5.4858 9.02273L1.44034 11.625L0.201705 9.46591L4.49716 7.27273L0.201705 5.07954L1.44034 2.92045L5.4858 5.52273L5.26989 0.727272H7.7358L7.51989 5.52273L11.5653 2.92045L12.804 5.07954L8.50852 7.27273L12.804 9.46591L11.5653 11.625L7.51989 9.02273L7.7358 13.8182H5.26989Z",
    fill: "#F3E61B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/_.64f101ecbb7ff04d55ab4135a12a67b9.svg";
export { ForwardRef as ReactComponent };